var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1665 5C34.2292 5 38.3332 9.10406 38.3332 14.1667C38.3332 17.906 36.3866 21.524 33.4813 22.2222C32.3607 22.4915 31.4682 23.9296 31.6599 25.5714C31.9166 27.7689 33.9038 29.989 37.8385 31.7385C38.7145 32.1281 38.3477 33.446 37.3964 33.3269C27.1421 32.0431 20.0341 25.3579 20 15.8997C19.9999 9.39508 23.8429 5 29.1665 5Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16655 5C14.2292 5 18.3332 9.10406 18.3332 14.1667C18.3332 17.906 16.3866 21.524 13.4813 22.2222C12.3607 22.4915 11.4682 23.9296 11.6599 25.5714C11.9166 27.7689 13.9038 29.989 17.8385 31.7385C18.7145 32.1281 18.3477 33.446 17.3964 33.3269C7.14208 32.0431 0.0341 25.3579 2.94371e-09 15.8997C-0.000122814 9.39508 3.84286 5 9.16655 5Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.2f787e682906636b9c01cfff2b79d845.svg";
export { ForwardRef as ReactComponent };